module.exports = __webpack_public_path__ + "static/media/mobile_data.a2b4e916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/desenvolvendoApis/mobile_data.png
// module id = 279
// module chunks = 0